import { get } from './';
export const getSustainableLevels = ({ search }) =>
  get(`/api/v1/sustainables?search=${search ?? ''}`);
